"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forumAuthorDisplayName = exports.isPartnerForForumBrand = void 0;
var User_1 = require("../User");
var membershipUtils_1 = require("./membershipUtils");
/** Partner persona for ModernSea Forum branding (Support / Core / Strategic share one UI). */
var isPartnerForForumBrand = function (role, membershipTypeSlug) {
    return role === User_1.UserRole.Partner || (0, membershipUtils_1.isPartnerMembershipType)(membershipTypeSlug !== null && membershipTypeSlug !== void 0 ? membershipTypeSlug : undefined);
};
exports.isPartnerForForumBrand = isPartnerForForumBrand;
var forumAuthorDisplayName = function (author) {
    var _a, _b, _c, _d;
    if ((0, exports.isPartnerForForumBrand)((_a = author.role) !== null && _a !== void 0 ? _a : User_1.UserRole.Regular, (_b = author.currentMembership) === null || _b === void 0 ? void 0 : _b.membershipTypeSlug) ||
        author.role === User_1.UserRole.Partner) {
        var name_1 = (_c = author.forumBusinessName) === null || _c === void 0 ? void 0 : _c.trim();
        return name_1 || 'Partner';
    }
    return (_d = author.fullName) !== null && _d !== void 0 ? _d : 'Member';
};
exports.forumAuthorDisplayName = forumAuthorDisplayName;
//# sourceMappingURL=forumPartner.js.map